import { render, staticRenderFns } from "./MaterialVariantTrackingToggle.vue?vue&type=template&id=38f36967&scoped=true"
import script from "./MaterialVariantTrackingToggle.vue?vue&type=script&lang=js"
export * from "./MaterialVariantTrackingToggle.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariantTrackingToggle.vue?vue&type=style&index=0&id=38f36967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f36967",
  null
  
)

export default component.exports